import React from 'react'

import DaiOptOutContext from 'contexts/DaiOptOutContext'
import useFetch from 'hooks/useFetch'
import useAuth from 'hooks/useAuth'

import * as service from 'service'

const DaiOptOutProvider = ({
  children,
  useAuthHook = useAuth,
  fetchService = service.dponet.daiOptOuts.get,
}) => {
  const { company, user } = useAuthHook()

  // No portal de convidados a company vem do token do link, antes do login
  const { response, isLoadingStart, refresh } = useFetch(
    fetchService,
    [],
    [company?.id, user?.id],
    !!company?.id && !!user,
  )

  const daiOptOuts = response?.data?.daiOptOuts

  return (
    <DaiOptOutContext.Provider value={{ daiOptOuts, isLoadingStart, refresh }}>
      {children}
    </DaiOptOutContext.Provider>
  )
}

export default DaiOptOutProvider
